// src/pages/AdminUserList.jsx
import React, { useEffect, useState } from "react";
import {
  Box,
  Heading,
  Spinner,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Button,
  useToast,
  Flex,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { useCognito } from "../utils/useCognito";
import axios from "axios";

const AdminUserList = () => {
  const { getIdToken } = useCognito();
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const toast = useToast();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = getIdToken();
        const res = await axios.post(
          "https://w6mxt54h5f.execute-api.us-east-2.amazonaws.com/Prod/api/getUser",
          {},
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setUsers(res.data.users);
      } catch (err) {
        console.error("Error fetching users:", err);
        toast({
          title: "Failed to load users",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      } finally {
        setLoading(false);
      }
    };
    fetchUsers();
  }, [getIdToken, toast]);

  if (loading) {
    return (
      <Flex minH="100vh" align="center" justify="center">
        <Spinner size="xl" />
      </Flex>
    );
  }

  return (
    <Box p={6}>
      <Heading mb={6}>All Users</Heading>
      <Table variant="simple">
        <Thead>
          <Tr>
            <Th>Name</Th>
            <Th>Email</Th>
            <Th>Actions</Th>
          </Tr>
        </Thead>
        <Tbody>
          {users.map((user) => (
            <Tr key={user.UserId}>
              <Td>{user.FirstName} {user.LastName}</Td>
              <Td>{user.email}</Td>
              <Td>
                <Button
                  colorScheme="blue"
                  onClick={() =>
                    navigate(`/tools/users/${user.UserId}/edit-baa?email=${encodeURIComponent(user.email)}`)
                  }
                >
                  Update Practice Data
                </Button>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  );
};

export default AdminUserList;
